import React from "react";
import * as S from "./notification-page.styles";
import { useTranslation } from "react-i18next";
import { Button } from "components/atoms/button";

const NotificationPage = ({ header, body, image, footer, buttonProps }) => {
  const { t } = useTranslation();

  return (
    <>
      <S.StyledCard>
        <S.StyledCardHeader>{t(header)}</S.StyledCardHeader>
        <S.Container>
          {image && (
            <S.ImageContainer>
              <S.StyledImage src={image} alt="Notification" />
            </S.ImageContainer>
          )}
          <S.BodyContainer>{t(body)}</S.BodyContainer>
          <S.FooterContainer>{t(footer)}</S.FooterContainer>
          {buttonProps && (
            <Button
              onClick={() =>
                buttonProps.href
                  ? (window.location.href = buttonProps.href)
                  : null
              }
              value={buttonProps.value}
            />
          )}
        </S.Container>
      </S.StyledCard>
    </>
  );
};

export default NotificationPage;
